import { render, staticRenderFns } from "./StudentDualMajor.vue?vue&type=template&id=dc1ea1a8&"
import script from "./StudentDualMajor.vue?vue&type=script&lang=js&"
export * from "./StudentDualMajor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports